module.exports = __webpack_public_path__ + "img/icon4.7757a81e.svg";